module.exports = __webpack_public_path__ + "img/qritem1.57c54e7d.png";